export const TRUNCATE_THRESHOLD = 500;
export const URL_REGEX = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
export const TRAILING_PUNCTUATION_REGEX = /[.,;:!?]+$/;

const cleanSummaryText = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  return text.replace(/\s*Here are some search results\.?\s*/gi, '').trim();
};

export const extractSummaryText = (serverData) => {
  if (!serverData?.summary) return null;

  const summaryWithMetadata = serverData.summary.summaryWithMetadata;
  if (summaryWithMetadata?.summary) {
    return cleanSummaryText(summaryWithMetadata.summary);
  }

  if (serverData.summary.answerText) {
    return cleanSummaryText(serverData.summary.answerText);
  }

  if (serverData.summary.text) {
    return cleanSummaryText(serverData.summary.text);
  }

  if (typeof serverData.summary === 'string') {
    return cleanSummaryText(serverData.summary);
  }

  return null;
};

export const extractReferences = (serverData) => {
  const rawReferences = 
    serverData?.summary?.summaryWithMetadata?.references ||
    serverData?.summary?.references ||
    serverData?.references ||
    [];
  
  return rawReferences.map((ref) => {
    if (ref?.chunkInfo?.documentMetadata) {
      const docMeta = ref.chunkInfo.documentMetadata;
      const title = docMeta.title || 
                   (docMeta.structData?.title && Array.isArray(docMeta.structData.title) 
                     ? docMeta.structData.title[0] 
                     : docMeta.structData?.title) ||
                   '';
      
      return {
        uri: docMeta.uri,
        title: title,
        ...docMeta
      };
    }
    if (ref?.documentMetadata) {
      return {
        uri: ref.documentMetadata.uri,
        title: ref.documentMetadata.title,
        ...ref.documentMetadata
      };
    }
    return ref;
  });
};

export const processCitations = (citations = []) => {
  if (!citations || citations.length === 0) {
    return [0, []];
  }
  
  return citations.reduce(
    ([lastEndIndex, accumulatedCitations], citation) => {
      const startIndex = typeof citation.startIndex === 'string' 
        ? parseInt(citation.startIndex, 10) 
        : (citation.startIndex || 0);
      const endIndex = typeof citation.endIndex === 'string'
        ? parseInt(citation.endIndex, 10)
        : (citation.endIndex || 0);
      
      if (lastEndIndex < startIndex) {
        accumulatedCitations.push({
          startIndex: lastEndIndex,
          endIndex: startIndex,
        });
      }
      
      accumulatedCitations.push({
        ...citation,
        startIndex,
        endIndex,
      });
      
      return [endIndex, accumulatedCitations];
    },
    [0, []]
  );
};

export const normalizeUrl = (url) => {
  const cleanUrl = url.replace(TRAILING_PUNCTUATION_REGEX, '');
  const trailingPunctuation = url.substring(cleanUrl.length);
  const href = cleanUrl.startsWith('www.') 
    ? `https://${cleanUrl}` 
    : cleanUrl;

  return { cleanUrl, href, trailingPunctuation };
};

